import React from "react";
import { SvgIcon } from "@material-ui/core";

const ResumeIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <path d="M30.727 33.001h-4.99a.318.318 0 01-.317-.318V27.67h-2.253v5.013a.318.318 0 01-.318.318h-4.99a.318.318 0 01-.318-.318v-9.421h-2.224a.317.317 0 01-.206-.56l2.771-2.354v-3.509a.318.318 0 01.317-.318h2a.318.318 0 01.318.318v1.267l3.566-3.031a.317.317 0 01.412 0l8.975 7.627a.317.317 0 01-.206.56H31.04v9.421a.318.318 0 01-.313.318z" />
    <path d="M0 0h48v48H0z" fill="none" />
  </SvgIcon>
);
ResumeIcon.displayName = "ResumeIcon";
ResumeIcon.muiName = "ResumeIcon";

export default ResumeIcon;
